class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.maxVisibleSwatches = parseInt(this.dataset.maxVisibleSwatches) || 5; // Maximum number of swatches to show initially
  }

  connectedCallback() {
    this.querySelectorAll('.color-swatch').forEach((s) => s.addEventListener('click', this.onSwatchClick.bind(this)));
    this.initSwatchOverflow();
  }

  initSwatchOverflow() {
    const swatchContainer = this.querySelector('.product-color-swatches');
    if (!swatchContainer) return;

    const swatches = swatchContainer.querySelectorAll('.color-swatch');
    if (swatches.length <= this.maxVisibleSwatches) return;

    // Hide excess swatches
    swatches.forEach((swatch, index) => {
      if (index >= this.maxVisibleSwatches) {
        swatch.style.display = 'none';
        swatch.classList.add('hidden-swatch');
      }
    });

    // Create and add 'more' button
    const moreButton = document.createElement('button');
    moreButton.className = 'swatch-more-btn';
    moreButton.innerHTML = `+${swatches.length - this.maxVisibleSwatches} more`;
    moreButton.addEventListener('click', this.toggleSwatches.bind(this));
    swatchContainer.appendChild(moreButton);
  }

  toggleSwatches(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const swatchContainer = this.querySelector('.product-color-swatches');
    const hiddenSwatches = swatchContainer.querySelectorAll('.hidden-swatch');
    const moreButton = swatchContainer.querySelector('.swatch-more-btn');
    const isExpanded = moreButton.classList.contains('expanded');

    if (isExpanded) {
      // Collapse: hide excess swatches
      hiddenSwatches.forEach(swatch => {
        swatch.style.display = 'none';
      });
      moreButton.innerHTML = `+${hiddenSwatches.length} more`;
      moreButton.classList.remove('expanded');
    } else {
      // Expand: show all swatches
      hiddenSwatches.forEach(swatch => {
        swatch.style.display = 'block';
      });
      moreButton.innerHTML = 'less';
      moreButton.classList.add('expanded');
    }
  }

  onSwatchClick(event) {
    const swatch = event.target;
    const productImage = this.querySelector(`[data-product-image="${this.dataset.productId}"]`);
    const swatchImageElement = swatch.querySelector('.data-variant-image');
    const newImageUrl = swatchImageElement ? swatchImageElement.getAttribute('src') : null;
    const newSrcset = swatchImageElement ? swatchImageElement.getAttribute('srcset') : null;

    this.querySelectorAll('.color-swatch').forEach((s) => s.classList.remove('selected'));
    swatch.classList.add('selected');

    if (productImage && swatchImageElement) {
      productImage.src = newImageUrl;
      productImage.srcset = newSrcset;
    }
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}